import { useEffect, useState } from "react";

import { InputText } from "@shared/features/form/components/input-text";
import { Button } from "@shared/components/ui/Button";
import { api } from "@shared/features/api/services/common/base";
import { useUser } from "@shared/features/auth/hooks/useUser";
import { TextTooltip } from "@shared/components/ui/TextTooltip";
import { cn } from "@shared/utils/cn";
import { useAuth } from "@shared/features/auth/hooks/useAuth";
import { config } from "@shared/config";

import { DebugCard } from "./debug-card";

export const ImpersonateButton = ({ email, onClick, children }) => {
  const user = useUser();

  return (
    <TextTooltip content={email} asChild>
      <Button
        tabIndex={-1}
        className={cn(
          "bg-gray-400 border-gray-400 hover:bg-gray-500",
          user.username === email &&
          "bg-primary border-primary pointer-events-none"
        )}
        onClick={() => onClick(email)}
      >
        {children}
      </Button>
    </TextTooltip>
  );
};

export const DebugCardImpersonate = () => {
  const auth = useAuth();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (auth.session && auth.user && auth.session.isImpersonation) {
      if (!email) {
        setEmail(auth.user.username);
      }
    }
  }, [auth]);

  const impersonate = async (email) => {
    setEmail(email);
    setIsLoading(true);

    try {
      await api.post(`/auth/impersonate`, { email });
      window.location.reload();
    } catch (err) {
      setIsLoading(false);
      alert("Error: " + err.message);
    }
  };

  return (
    <DebugCard
      title="Impersonate user"
      className="text-sm px-10 flex flex-col gap-4"
    >
      <div
        className="flex flex-col gap-4"
      >
        <InputText
          value={email}
          onChange={(email) => setEmail(email)}
          // @ts-expect-error InputTextProps lacks placeholder, which is spread onto the input
          placeholder="john.doe@acme.com"
          type="email"
          readOnly={isLoading}
        />
        <div className="flex justify-end gap-4">
          {auth.session && auth.session.isImpersonation && (
            <TextTooltip content={auth.session.originalUsername} asChild>
              <Button
                tabIndex={-1}
                onClick={() => impersonate(auth.session.originalUsername)}
                variant="outline"
                className="text-red border-red hover:bg-red/10 bg-transparent"
              >
                Restore user
              </Button>
            </TextTooltip>
          )}
          <Button
            variant="outline"
            className="bg-red text-white border-red"
            isLoading={isLoading}
            disabled={email === auth?.user?.username}
            onClick={() => impersonate(email)}
          >
            Impersonate
          </Button>
        </div>
      </div>
    </DebugCard>
  );
};
